import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/SubscribeEmailListApi/SubscribeEmailList";
import { validateForm } from "utils/validation";
import { SubscriberAddRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditMemberForm from "./Componates/EditMemberForm";
import fields from "../json/SubscribeEmailList.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const MemberEdit = () => {
  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    SubscriberAddRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await Update({ id, data: { email: formValues.email } });
    },
    (vals) => {
      const err = validateForm(vals, SubscriberAddRules);
      setErrors(err);
      return err;
    },
    () => {
      navigate(-1);
    },
    "Member updated successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditMemberForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Member"
      />
    </>
  );
};

export default MemberEdit;